import styled from 'styled-components';
import colors from '@theme/colors';

export const MessagesList = styled.ul`
  color: ${colors.TEXT};
  padding: 10px 0;
  margin: 0;
  > li {
    list-style: none;
    padding: 10px 0;
    display: flex;
    justify-content: space-between;
  }
`;



// WEBPACK FOOTER //
// ./components/layout/AdminPage.js